export default __webpack_public_path__ + "static/media/eryk-bw.fcc8f222.jpeg";